import { SegmentPeriodInfo } from 'src/models/segment-cdt/SegmentCdtTypes';

/**
 * The newest period that holds rows, which the segment table detail view opens on.
 * @returns The period (YYYYMM), or undefined when the table has no rows yet.
 */
export function latestPeriod(periods: SegmentPeriodInfo[]): string | undefined {
    return periods.map((p) => p.period).filter((p): p is string => !!p).sort().reverse()[0];
}
